import { Component, OnInit, Input, Output } from '@angular/core';
import { VisorService } from '../../services/visor.service';

import * as moment from 'moment/moment'; //add this
import 'moment/locale/es';

declare var jQuery: any;

@Component({
  selector: 'notas-component',
  templateUrl: './notas.component.html',
  styleUrls: ['./notas.component.css']
})
export class NotasComponent implements OnInit {

  constructor(private visorService: VisorService) { }

  @Input() block: any;

  hasComments = false;
  hasNotes = false;
  totalComments = 0;
  totalNotes = 0;
  Comments: Array<any>;
  Notes: Array<any>;
  showComments = false;
  showNotes = false;
  guid: string;

  ngOnInit() {
    let now = moment();

    let guid = this.block.block["@GUID"];

    this.guid = guid;

    this.visorService.getNotes(guid).subscribe(n => {
      if (n.length) {
        this.setNotes(n);
      }
    });

    this.visorService.getComments(guid).subscribe(c => {
      if (c.length) {
        this.setComments(c);
      }
    });
  }

  setComments(Comments: Array<any>) {
    Comments.forEach(item => {
      let pDate = this.processDate(item.Fecha).oDate;
      item.date = moment(pDate).format("D-MM-YY");
      item.moment = moment(pDate).fromNow();
      item.dateOrder = pDate;
      //item.clase = (data.nota && parseFloat(data.nota.idComentario) === parseFloat(item.IdComentario)) ? "resaltado" : "";
      item.clase = "";
      item.expanded = false;
    });


    this.Comments = Comments.sort((a, b) => b.dateOrder - a.dateOrder);
    this.hasComments = true;
    this.totalComments = this.Comments.length;
  }

  setNotes(Notes: Array<any>) {
    Notes.forEach(item => {
      let pDate = this.processDate(item.Fecha).oDate;
      item.date = moment(pDate).format("D-MM-YY");
      item.moment = moment(pDate).fromNow();
      item.dateOrder = pDate;
      //item.clase = (data.nota && parseFloat(data.nota.idComentario) === parseFloat(item.IdComentario)) ? "resaltado" : "";
      item.clase = "";
      item.expanded = false;
    });


    this.Notes = Notes.sort((a, b) => b.dateOrder - a.dateOrder);
    this.hasNotes = true;
    this.totalNotes = this.Notes.length;
  }

  processDate(dateStr) {
    var re = /([\/][Date(]*)([0-9]*)([)\/]*)/;
    var str = dateStr;
    var subst = '$2';

    var result = str.replace(re, subst);
    var dateResult = '';
    var dateResultShort = '';
    var days = ["Domingo", "Lunes", "Martes", "Miercoles", "Jueves", "Viernes", "Sabado"];
    var months = ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"];
    if (result) {
      //var dateRslt = new Date(parseInt(result));
      var dateRslt = moment(dateStr).toDate();
      dateResult = days[dateRslt.getDay()] + ',' + dateRslt.getDate() + ' de ' + months[dateRslt.getMonth()] + ' de ' + dateRslt.getFullYear() + ' ( ' + dateRslt.getHours() + ':' + dateRslt.getMinutes() + ' ) ';
      dateResultShort = this.getShortDate(dateRslt);
    }

    var d = { large: dateResult, short: dateResultShort, oDate: dateRslt };

    return d;
  }

  getShortDate(dateIn) {
    return dateIn.getDay() + '.' + (dateIn.getMonth() + 1) + '.' + dateIn.getFullYear();
  }

  clickComments(event) {
    this.showNotes = false;
    this.showComments = !this.showComments;
  }

  clickNotes(event) {
    this.showComments = false;
    this.showNotes = !this.showNotes;
  }

  clickAddNote(event) {
    if(typeof jQuery === "function")
      jQuery("#findArticlesAddNoteDialog").modal("show");
  }
}



// WEBPACK FOOTER //
// C:/Workspaces/Redjurista/MAIN/Source/Asterysco.AJ.Lawtheque/GUI/Angular Components/findarticles/src/app/articulo/notas/notas.component.ts